/* eslint-disable-next-line no-unused-vars */
export const create = (initialData) => {
  return {};
};
